import * as React from "react";
import { legacyClients } from "./legacyClients/legacyClients";
import { datasetsClient, kernelsClient, searchClient, tagsClient, userSecretsClient } from "./sdk";
import { abuseClient } from "./generated/abuse";
import { competitionsClient } from "./generated/competitions";
import { competitionsLegacyClient } from "./generated/competitions/legacy";
import { datasetsDatabundlesClient } from "./generated/datasets/databundles";
import { educationClient } from "./generated/education";
import { usersClient } from "./generated/users";
export var bothClients = {
    clients: {
        abuseClient: abuseClient,
        competitionsClient: competitionsClient,
        competitionsLegacyClient: competitionsLegacyClient,
        datasetsClient: datasetsClient,
        datasetsDatabundlesClient: datasetsDatabundlesClient,
        educationClient: educationClient,
        kernelsClient: kernelsClient,
        searchClient: searchClient,
        tagsClient: tagsClient,
        usersClient: usersClient,
        userSecretsClient: userSecretsClient
    },
    legacyClients: legacyClients
};
export var ClientsContext = /*#__PURE__*/ React.createContext(bothClients);
